import {Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {toPng} from 'html-to-image';
import {ITextConfig} from '../../Interfaces';
import {Dimensions} from '../../object3D';
import { ArrowHolder } from '../../object3D/Dimensions/ArrowHolder';
// import { DeleteObjectComponent } from '../../components';


@Component({
  selector: 'app-dimensions-edit-dialog',
  templateUrl: 'dimensions-editor.component.html',
  styleUrls: ['./dimensions-editor.component.scss']
})
export class DimensionsEditorComponent {

  ftValue: number = 0;
  inchValue: number = 0;
  text: string;
  needArrow: boolean = true;
  @ViewChild('editorElement') editorElement: ElementRef;
  changed: any;

  constructor(
    private dialogRef: MatDialogRef<DimensionsEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Dimensions | null
    // private deleteComponent: DeleteObjectComponent
  ) {
    this.changed = false;
    if (data) {
      this.getSizeInImperial(data.Length);
      this.changed = true;
      this.needArrow = data.getObjectByName<ArrowHolder>("firstArrow").visible;
    } else {
      this.ftValue = 0;
      this.inchValue = 0;
    }
    this.text = this.ftValue + "\'" + this.inchValue + "\"";
  }

  getStyles() {
    return {
      'font-weight': 'normal',
      'text-decoration': 'none',
      'font-style': 'normal'
    };
  }

  getSizeInImperial(length) {
    const convert = length * 0.3937008;
    let FT = convert / 12;
    FT = Math.floor(FT);
    const dif = convert / 12 - FT;
    let INCH = dif / (1 / 12);
    INCH = parseFloat(INCH.toFixed(0));
    if (INCH === 12) {
      FT += 1;
      INCH = 0;
    }
    this.ftValue = FT;
    this.inchValue = INCH;
  }

  changeFtValue(value) {
    this.changed = true;
    let numbValue: number = +value;
    if (numbValue < 0) {
      this.ftValue = 0;
      this.text = this.ftValue + "\'" + this.inchValue + "\"";
    }
    else {
      this.ftValue = numbValue;
      // console.log(this.ftValue);
      this.text = this.ftValue + "\'" + this.inchValue + "\"";
    }
  }

  changeInchValue(value) {
    this.changed = true;
    let numbValue: number = +value;
    if (numbValue < 0) {
      this.inchValue = 0;
      this.text = this.ftValue + "\'" + this.inchValue + "\"";
    }
    else if (numbValue >= 12) {
      let Ft = Math.floor(numbValue / 12);
      this.ftValue += Ft;
      this.inchValue = numbValue % 12;
      this.text = this.ftValue + "\'" + this.inchValue + "\"";
    } else {
      this.inchValue = numbValue;
      this.text = this.ftValue + "\'" + this.inchValue + "\"";
    }
  }

  async apply() {
    const result = {
      text: this.text,
      needArrow: this.needArrow,
      changed: this.changed
    }
    this.dialogRef.close(result);
    // this.deleteComponent.enable();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/ng-components/dimensions-editor/dimensions-editor.component.ts